import { Button } from '@/shared/ui'

import { CustomStoriesSlide } from '../custom-stories'
import type { IStoriesContext, TStoryAction } from '../types'

import styles from './driver-recharge.module.scss'

import {
    IllustrationOnboarding1,
    IllustrationOnboarding2,
    IllustrationOnboarding3,
    IllustrationOnboardingDark1,
    IllustrationOnboardingDark2,
    IllustrationOnboardingDark3,
} from '@/assets'

export const DriverRechargeStories = ({
    setShowStories,
    setCurrentIndex,
    onActionUpdate,
    theme,
}: IStoriesContext) => [
    {
        content: ({ action }: { action: TStoryAction }) => (
            <CustomStoriesSlide action={action} onActionUpdate={onActionUpdate}>
                <div className={styles['driver-recharge-stories']}>
                    <h1 className={styles['driver-recharge-stories__title']}>
                        Пополняйте счёт <br />
                        по-новому
                    </h1>
                    <p className={styles['driver-recharge-stories__description']}>
                        Обновили дизайн и сократили шаги в <br /> пополнении счёта
                    </p>
                    <img
                        alt='payment'
                        className={styles['driver-recharge-stories__image']}
                        src={
                            theme === 'light' ? IllustrationOnboarding1 : (
                                IllustrationOnboardingDark1
                            )
                        }
                    />
                    <Button
                        className={styles['driver-recharge-stories__button']}
                        variant='primary'
                        onClick={() => {
                            action('play')
                            setCurrentIndex((previous) => Math.min(previous + 1, 2))
                        }}
                    >
                        Отлично
                    </Button>
                </div>
            </CustomStoriesSlide>
        ),
    },
    {
        content: ({ action }: { action: TStoryAction }) => (
            <CustomStoriesSlide action={action} onActionUpdate={onActionUpdate}>
                <div className={styles['driver-recharge-stories']}>
                    <h1 className={styles['driver-recharge-stories__title']}>Быстрее и удобнее</h1>
                    <p className={styles['driver-recharge-stories__description']}>
                        Ввод суммы и выбор метода <br />
                        оплаты — теперь в одном месте
                    </p>
                    <img
                        alt='payment'
                        className={styles['driver-recharge-stories__image']}
                        src={
                            theme === 'light' ? IllustrationOnboarding2 : (
                                IllustrationOnboardingDark2
                            )
                        }
                    />
                    <Button
                        className={styles['driver-recharge-stories__button']}
                        variant='primary'
                        onClick={() => {
                            action('play')
                            setCurrentIndex((previous) => Math.min(previous + 1, 2))
                        }}
                    >
                        Супер
                    </Button>
                </div>
            </CustomStoriesSlide>
        ),
    },
    {
        content: ({ action }: { action: TStoryAction }) => (
            <CustomStoriesSlide action={action} onActionUpdate={onActionUpdate}>
                <div className={styles['driver-recharge-stories']}>
                    <h1 className={styles['driver-recharge-stories__title']}>
                        Выбирайте способ <br /> пополнения
                    </h1>
                    <p className={styles['driver-recharge-stories__description']}>
                        И мы запомним его. Поехали?
                    </p>
                    <img
                        alt='payment'
                        className={styles['driver-recharge-stories__image']}
                        src={
                            theme === 'light' ? IllustrationOnboarding3 : (
                                IllustrationOnboardingDark3
                            )
                        }
                    />
                    <Button
                        className={styles['driver-recharge-stories__button']}
                        variant='primary'
                        onClick={() => {
                            action('play')
                            setShowStories()
                        }}
                    >
                        К пополнению счёта
                    </Button>
                </div>
            </CustomStoriesSlide>
        ),
    },
]
